import React from 'react'
import './css/TestimonialCard.css'

function TestimonialCard({icon, content, name}) {
  return (
    <div className='TestimonialCard'>
        <img src={icon} alt='Profile' />
        <p className='content'>{content}</p>
        <h4 className='name'>{name}</h4>
    </div>
  )
}

export default TestimonialCard